import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["header", "title", "details", "steps", "element"]
  declare readonly headerTarget: HTMLElement
  declare readonly titleTarget: HTMLElement
  declare readonly detailsTarget: HTMLElement
  declare readonly stepsTarget: HTMLElement
  declare readonly elementTarget: HTMLElement

  connect() {
    this.handleScroll = this.handleScroll.bind(this)
    this.elementTarget.addEventListener('scroll', this.handleScroll)
  }

  disconnect() {
    this.elementTarget.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll() {
    const scrollTop = this.elementTarget.scrollTop
    const compact = scrollTop > 20

    this.titleTarget.classList.toggle('text-2xl', !compact)
    this.titleTarget.classList.toggle('text-xl', compact)
    this.detailsTarget.classList.toggle('hidden', compact)
  }
}